<template>
    <div class="ds-display-flex ds-align-items-center ds-flex-wrap ds-color-black">
        <nav>
            <ul
                class="ds-display-flex"
                role="menubar">
                <li
                    v-for="(item, index) in items"
                    :key="`secondary-navigation-item-${index}`"
                    class="ds-display-flex ds-align-items-center ds-text-small"
                    role="none">
                    <DsAnchorElement
                        :url="item.url"
                        :open-in-new-window="item.openInNewWindow"
                        :nuxt="item.nuxt"
                        class="ds-footer-secondary-navigation-link"
                        role="menuitem"
                        @link-clicked="(e) => $parent.$emit('link-clicked-proxy', {...e, type: 'secondaryLink' })">
                        {{ item.title }}
                    </DsAnchorElement>
                    <div class="ds-margin-x-3">·</div>
                </li>
            </ul>
        </nav>
        <p class="ds-text-small" data-j-copyright>
            &#169; {{ new Date().getFullYear() }} Adyen
        </p>
    </div>
</template>

<script>
/**
 * Footer secondary navigation component.
 * It's meant to be used with the footer component
 *
 * @emits link-clicked-proxy
 */

import { DsAnchorElement } from '../../../atoms';

export default {
    name: 'DsFooterSecondaryNavigation',
    components: { DsAnchorElement },
    props: {
        items: { type: Array, required: true }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../foundation/tokens/variables';
@import '../../../foundation/mixins/buttons/button-link-states.mixins';

.ds-footer-secondary-navigation-link {
    @include button-link-states(
        $color-black, // text-color
        $color-black, // text-hover-color
        true, // text-hover-underline
        $color-black // border-focus-color
    );
}
</style>
